export enum TmxProfillingActionTypes {
    SET_TMX_LOAD_ERROR = "SET_TMX_LOAD_ERROR",
    SET_TMX_PROFILING_IS_COMPLETED = "SET_TMX_PROFILING_IS_COMPLETED"
}

type SetTmxProfilingIsCompletedAction = {
    type: TmxProfillingActionTypes.SET_TMX_PROFILING_IS_COMPLETED,
    payload: { isTmxProfilingCompleted: boolean }
}

export const setTmxProfilingIsCompleted = (isTmxProfilingCompleted: boolean): SetTmxProfilingIsCompletedAction => ({
    type: TmxProfillingActionTypes.SET_TMX_PROFILING_IS_COMPLETED,
    payload: { isTmxProfilingCompleted }
});

type SetTmxLoadErrorAction = {
    type: TmxProfillingActionTypes.SET_TMX_LOAD_ERROR,
    payload: { error: string }
}

export const setTmxLoadError = (error: string): SetTmxLoadErrorAction => ({
    type: TmxProfillingActionTypes.SET_TMX_LOAD_ERROR,
    payload: { error }
});


export type TmxActions =
    SetTmxLoadErrorAction |
    SetTmxProfilingIsCompletedAction;


